import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

//import theme from '../../../theme';
//import { grey } from '@material-ui/core/colors';

import {Dialog, DialogActions, DialogContent, DialogTitle} from '@material-ui/core'
import {Container, Box, TextField, Button} from '@material-ui/core'
//Typography, Paper
//import {ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails} from '@material-ui/core';
//import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { isInteger, isNumber } from '../../../api/validators';
//import { getObjectByID } from '../../../api/helpers';

class EditDmrUserDialog_ extends React.Component{

    constructor(props){
        super(props)

        let user = JSON.parse(JSON.stringify(this.props.user))

        //user defaults
        //console.log('EditUserDialog')
        //console.log(props)

        if(!user.ID) user = {
            Name: '',
            RadioID: 0,
        }

        this.state = {
            user: {...user},
            errors:{
                Name: false,
                RadioID: false,
            },
            changed: false,
        }   

        this.handleInput = this.handleInput.bind(this)

        this.handleSave = this.handleSave.bind(this)
        this.handleClose = this.handleClose.bind(this)
    }

    handleSave(){
        if(this.checkForm()){
            let user = {...this.props.user, ...this.state.user}
            this.props.onAction({type: 'DMR_USER_EDITOR_SAVE', user: user})
        }else{
            this.props.onAction({type:'ALERT_DIALOG', message: this.props.t('CheckFormForErrors')})
        }
    }

    handleClose(){
        if(this.state.changed){
            this.props.onAction({
                type: 'CONFIRM_DIALOG', 
                message: this.props.t('CloseFormConfirm'),
                onConfirm: ()=>{
                    this.props.onAction({type: 'DMR_USER_EDITOR_CLOSE'})
                }
            })
        }else{
            this.props.onAction({type: 'DMR_USER_EDITOR_CLOSE'})
        }
    }

    handleInput(event){
        let changed = !this.state.changed ? {changed: true} : {}
        let val =  event.target.type==='checkbox' ? event.target.checked : event.target.value

        const err = this.validate(event.target.name, val)

        if(!err){
            //type casts
            switch(event.target.name){
                case 'RadioID': 
                    val = Number(val) 
                    break
            }
        }

        const user = {...this.state.user, [event.target.name]: val}


        const errors = {errors: {...this.state.errors, [event.target.name]: err}}
        //console.log('handleInput')
        //console.log(event.target.name)
        //console.log(errors)

        this.setState({user: user, ...changed, ...errors})
    }


    validate(name, value){
        const {t} = this.props
        let error = false

        switch(name){

            case 'Name':
                if(!value){
                    error = t('NameIsEmpty')
                }
                break

            case 'RadioID':
                if(value && !isNumber(value)){
                    error = this.label(name) + ': ' + t('IsNotNumber')
                }else if(value && !isInteger(value)){
                    error = t('IsNotInteger')
                }else if(!value){
                    error = false
                }
                break

            default:
                console.log('Empty validator '+name)
        }

        return error
    }

    label(name){
        let {t} = this.props
        switch(name){
            default: return t(name)
        }
    }


    checkForm(){
        //console.log('checkform')
        //console.log(this.state.user)
        //console.log(this.state.errors)
        let check = true
        let errors = {...this.state.errors}
        for(var i in errors){
            //console.log('check field '+i)
            let v = this.state.user[i]
            let error = this.validate(i, v)
            errors[i] = error
            if(error) {
                console.error({field: i, value: v, error: error})
                check = false
            }
        }
        //console.log(check + ' checkform')
        this.setState({errors: errors})
        return check
    }


    render(){
        const {t} = this.props

        //console.log('this.state.user')
        //console.log(this.state.user)
        //console.log('this.props.fieldsTemplate')
        //console.log(this.props.fieldsTemplate)

        const title = this.props.action==='add'?t('NewUser'):t('EditUser')

        const margin = {margin:'16px 0 8px 0'}


        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose}
    aria-labelledby="edit-dialog-title">
        
    <DialogTitle id="edit-dialog-title">{title}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:550}}>

            <Box textAlign="center">
                <TextField name="Name"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.Name?this.state.errors.Name:t('Name')}
                    autoComplete="new-password"
                    error={this.state.errors.Name!==false}
                    value={this.state.user.Name}
                    onChange={this.handleInput}
                />
            </Box>

            <Box textAlign="center">
                <TextField name="RadioID"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.RadioID?this.state.errors.RadioID:t('RadioID')}
                    autoComplete="new-password"
                    error={this.state.errors.RadioID!==false}
                    value={this.state.user.RadioID}
                    onChange={this.handleInput}
                />
            </Box>

        </Container>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSave} variant="contained" color="primary">
            {t('Apply')}
        </Button>
        <Button onClick={this.handleClose} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>
        );

    }
}

export const EditDmrUserDialog = withTranslation()(EditDmrUserDialog_);